if (!customElements.get('curated-quick-view')) {
  customElements.define(
    'curated-quick-view',
    class CuratedQuickView extends ModalDialog {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form) {
          this.form.addEventListener('submit', () => (this.pendingAdd = true));
        }

        this.addEventListener('change', (event) => {
          if (event.target.name === 'id') this.onVariantChange(event.target);
        });

        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (this.pendingAdd && event.source === 'product-form') {
            this.pendingAdd = false;
            this.hide();
          }
        });
        subscribe(PUB_SUB_EVENTS.cartError, () => (this.pendingAdd = false));
      }

      onVariantChange(input) {
        const price = this.querySelector('[data-price-display]');
        if (price && input.dataset.variantPrice) price.textContent = input.dataset.variantPrice;

        const compare = this.querySelector('[data-compare-display]');
        if (compare) {
          if (input.dataset.variantComparePrice) {
            compare.textContent = input.dataset.variantComparePrice;
            compare.removeAttribute('hidden');
          } else {
            compare.textContent = '';
            compare.setAttribute('hidden', '');
          }
        }

        const image = this.querySelector('.curated-quick-view__media img');
        if (image) image.src = input.dataset.image || image.dataset.defaultSrc;
      }
    }
  );
}

// Open the quick view when a curated product card's link is clicked, instead of
// navigating to the product page. Modified clicks (cmd/ctrl/shift/alt) keep the
// default link behavior so customers can still open the product page in a new tab.
document.addEventListener('click', (event) => {
  if (event.defaultPrevented) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

  const card = event.target.closest('.card-wrapper[data-curated-modal]');
  if (!card) return;
  if (event.target.closest('.quick-add, modal-opener, product-form')) return;

  const link = event.target.closest('a');
  if (!link) return;

  const modal = document.querySelector(card.dataset.curatedModal);
  if (!modal) return;

  event.preventDefault();
  modal.show(link);
});
